'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { CHOSE_VARIATION_WINNER } from '../actions/ActionTypes';
import { receiveVariations, requestChooseVariationWinner, requestedChooseVariationWinnerFailure, requestedChooseVariationWinnerSuccess, requestedVariationsFailed, requestVariations } from '../actions/VariationsActions';
export default ((action$, _, {
  VariationsClient
}) => action$.ofType(CHOSE_VARIATION_WINNER).pipe(mergeMap(({
  payload: {
    abTestId,
    contentType,
    variationId
  }
}) => VariationsClient.chooseWinner(abTestId, contentType, variationId).pipe(mergeMap(() => VariationsClient.fetch(abTestId, contentType).pipe(mergeMap(variations => of(receiveVariations(variations), requestedChooseVariationWinnerSuccess(contentType))), catchError(error => of(requestedVariationsFailed(error))), startWith(requestVariations()))), catchError(error => of(requestedChooseVariationWinnerFailure(error, contentType))), startWith(requestChooseVariationWinner())))));